import axios from 'axios';

export default {
  fetchDocuments({
    commit,
  }, params) {
    commit('setLoading', true);
    commit('setError', false);
    console.log(params);
    const { resource, resourceId } = params;
    let uri = '/';

    if (resource && resourceId) {
      uri += `${resource}/${resourceId}/`;
    }
    uri += 'document';
    console.log(`URI: ${uri}`);

    return axios.get(uri, {
      params,
    })
      .then((documents) => {
        console.log(documents);
        commit('setData', documents);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};
